export const state = () => ({
  radioAds: [],
  videoAds: []
});

export const mutations = {
  setRadioAds (state, radioAds) {
    state.radioAds = radioAds;
  },
  setVideoAds (state, videoAds) {
    state.videoAds = videoAds;
  }
};

export const getters = {
  getRadioAds (state) {
    return state.radioAds;
  },
  getVideoAds (state) {
    return state.videoAds;
  }
};
